import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { logger } from 'app/core/util/logger';
import { appSettings } from 'app/appSettings';
import { DefinitionsTO } from '../../store/definitions/definitions.interface';
import { default as cachedResponse } from './responses/getDefinitions';
import { RestService } from './rest.service';
import { firstValueFrom } from 'rxjs';
import { AzureMonitoringService } from '../AzureMonitoringService';

@Injectable({ providedIn: 'root' })
export class DefinitionRestService {
  constructor(private restService: RestService, private translate: TranslateService, private azureMonitoringService: AzureMonitoringService) {
  }

  getDefinitions(language: string): Promise<DefinitionsTO> {
    let response;
    let startTime = new Date().getTime();
    try {
      this.azureMonitoringService.logEvent('Will get definitions');
      response = this.restService.get<DefinitionsTO>(`/Definition/get?language=${(language || 'en').toUpperCase()}`);
      return firstValueFrom(response);
    } catch (error) {
      this.azureMonitoringService.logException(error, { message: 'definitions load fail', ...stringifyError(error), duration: new Date().getTime() - startTime });
      console.error(error);
      throw error;
    }
  }
}

function stringifyError(error: Error): Object {
  const result = {
    errorStringified: null,
    errorName: null,
    errorStack: null,
    errorMessage: null,
  };
  try { result.errorStringified = JSON.stringify(error) } catch (_) { }
  try { result.errorMessage = error.message } catch (_) { }
  try { result.errorName = error.name } catch (_) { }
  try { result.errorStack = error.stack } catch (_) { }
  return result;
}
